import {
  type FlyoutSearchContextState,
  type FlyoutSearchDisplayType,
} from "./context-flyout-search";

export function getSearchDisplayType(
  state: FlyoutSearchContextState,
): FlyoutSearchDisplayType {
  if (state.tagSelected) {
    return "posts";
  }
  if (state.tagSelectionEnabled) {
    return "tags";
  }

  return "posts";
}
